<template>
    <div class="row">
        <vue-headful :title="$t('appTitle')"></vue-headful>

        <component v-for="panel in page.settings"
                   :key="panel.sort"
                   :size="Number(panel.size)"
                   :is="panel.name">
        </component>

        <div class="row">
            <div v-for="(component, index) in nonDynamicRegistersDashboardComponents"
                :key="index"
                 class="mb-3"
                 :class="component.sizeClass">
                <component v-if="component.pinToDashboar"
                           :is="component.key"
                           :showHideButton="true"
                           :showPinButton="false"
                           :showNewButton="false"
                           :showResizeIcon="true"
                           :showSettingsBtn="false"
                           :size="component.size"
                           :showBtns="false"
                           :showHeadful="false"
                           @resize="resizeComponent"
                           @hide="hideComponent"
                           @pinned="pinnedComponenet"
                           @unpinned="unpinnedComponenet">
                </component>
            </div>

            <div v-for="(component, index) in dynamicRegistersDashboardComponents"
                :key="index"
                 class="mb-3"
                 :class="component.sizeClass">
                <dynamic-register-grid v-if="component.pinToDashboar"
                                       :registerName="component.key"
                                       :showHideButton="true"
                                       :showPinButton="false"
                                       :showNewButton="false"
                                       :showResizeIcon="true"
                                       :showSettingsBtn="false"
                                       :size="component.size"
                                       :showBtns="false"
                                       :showStatuses="false"
                                       :showHeadful="false"
                                       @resize="resizeComponent"
                                       @hide="hideComponent"
                                       @pinned="pinnedComponenet"
                                       @unpinned="unpinnedComponenet">
                </dynamic-register-grid>
            </div>
        </div>
    </div>
</template>

<script>
import EventsMap from '../components/home/EventsMap';
import MyLastParticipations from '../components/home/MyLastParticipations';
import MyForms from '../components/home/MyForms';
import MyLastActionLogs from '../components/home/MyLastActionLogs';
import LearningActivity from '../components/home/LearningActivity'
import OtherActivities from '../components/home/OtherActivities';
import UpcomingEvents from '../components/home/UpcomingEvents';
import PendingConfirmation from '../components/home/PendingConfirmation';
import ConfirmationsList from '../components/home/ConfirmationsList';
import { DynamicLayoutPages } from '../models/enums';
import AuditRegister from '../components/administration/audit/AuditRegister';
import ActionRegister from '../components/administration/audit/ActionRegister';
import OrganizersRegister from '../views/registers/organizers/List';
import DynamicRegisterGrid from './registers/dynamic/ListDynamicData';
import PageTitle from '../components/common/PageTitle';
import ParticipantHomeView from '../components/home/Participant';
import VueHeadful from 'vue-headful';
import { mapGetters } from 'vuex';

export default {
    name: 'home',
    components: {
        EventsMap,
        MyLastParticipations,
        MyLastActionLogs,
        LearningActivity,
        MyForms,
        OtherActivities,
        UpcomingEvents,
        PendingConfirmation,
        ConfirmationsList,
        PageTitle,
        auditregister: AuditRegister,
        actionregister: ActionRegister,
        organizersregister: OrganizersRegister,
        'dynamic-register-grid': DynamicRegisterGrid,
        ParticipantHomeView,
        VueHeadful
    },
    data() {
        return {
            page: {},
            dashboardComponents: {}
        };
    },
    computed: {
        ...mapGetters(['userSettings']),
        isNipEmployee() {
            return this.$store.getters.claims.nijEmployee.read;
        },
        dynamicRegistersDashboardComponents() {
            let objects = {};

            for (var componentName in this.dashboardComponents) {
                if (
                    componentName &&
                    this.dashboardComponents[componentName].isDynamicRegister
                ) {
                    this.$set(
                        objects,
                        componentName,
                        this.dashboardComponents[componentName]
                    );
                }
            }

            return objects;
        },
        nonDynamicRegistersDashboardComponents() {
            let objects = {};

            for (var componentName in this.dashboardComponents) {
                if (
                    componentName &&
                    !this.dashboardComponents[componentName].isDynamicRegister
                ) {
                    this.$set(
                        objects,
                        componentName,
                        this.dashboardComponents[componentName]
                    );
                }
            }

            return objects;
        },
    },
    methods: {
        sortPanels() {
            return this.page.settings.sort(function (a, b) {
                return a.sort - b.sort
            });
        },
        resizeComponent(componentName, size, grid) {
            if (
                this.dashboardComponents.hasOwnProperty(componentName) &&
                this.dashboardComponents[componentName].hasOwnProperty(
                    'pinToDashboar'
                )
            ) {
                this.dashboardComponents[componentName].size = size;
                this.dashboardComponents[componentName].sizeClass =
                    'col-md-' + size;
            }

            if (grid && grid.dataSource) {
                grid.dataSource.read();
            }
        },
        hideComponent(componentName) {
            if (
                this.dashboardComponents.hasOwnProperty(componentName) &&
                this.dashboardComponents[componentName].hasOwnProperty(
                    'pinToDashboar'
                )
            ) {
                this.dashboardComponents[componentName].pinToDashboar = false;
            }
        },
        pinnedComponenet(componentName) {
            if (
                this.dashboardComponents.hasOwnProperty(componentName) &&
                this.dashboardComponents[componentName].hasOwnProperty(
                    'pinToDashboar'
                )
            ) {
                this.dashboardComponents[componentName].pinToDashboar = true;
            }
        },
        unpinnedComponenet(componentName) {
            if (
                this.dashboardComponents.hasOwnProperty(componentName) &&
                this.dashboardComponents[componentName].hasOwnProperty(
                    'pinToDashboar'
                )
            ) {
                this.dashboardComponents[componentName].pinToDashboar = false;
            }
        },
        setupDashboardComponents() {
            this.loadUserSittings();
            for (const key in this.dashboardComponents) {
                if (
                    this.dashboardComponents.hasOwnProperty(key) &&
                    this.dashboardComponents[key].hasOwnProperty(
                        'pinToDashboar'
                    )
                ) {
                    this.checkIfPinnedToDashboard(key);
                }
            }
        },
        loadUserSittings() {
            this.$http
                .get('/api/personalization/dashboard')
                .then(response => {
                    for (var i = 0; i < response.data.settings.length; i++) {
                        this.$set(
                            this.dashboardComponents,
                            response.data.settings[i].componentName,
                            {
                                pinToDashboar: true,
                                key: response.data.settings[i].componentName,
                                isDynamicRegister:
                                response.data.settings[i].isDynamicRegister,
                                size: response.data.settings[i].size,
                                sizeClass: response.data.settings[i].sizeClass
                            }
                        );
                    }
                })
                .catch(error => {
                    this.$vs.notify({
                        title: this.$t(
                            'request.response.status.' +
                            this.$helpers.errorStatusCode(error)
                        ),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    });
                });
        },
        praparePanels(userSettings) {
            this.page = userSettings.filter(page => page.pageId === DynamicLayoutPages.Home)[0];
            this.page.settings = this.sortPanels();
        }
    },
    watch: {
        userSettings: function (newUserSettings, oldUserSettings) {
            this.praparePanels(newUserSettings)
        }
    },
    mounted() {
        if (this.userSettings && this.userSettings.length > 0) {
            this.praparePanels(this.userSettings)
        }

        this.setupDashboardComponents();
    },
};
</script>
